(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-recipes-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  const compact = value => String(value).normalize('NFKC').toLowerCase().replace(/[\u2010-\u2015\u2212\uFE58\uFE63-]/g, '').replace(/\s+/gu, '');
  async function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('.sr-recipes-grid');
    let next = root.querySelector('[data-next-page]');
    const seen = new Set();
    try {
      while (next) {
        const url = new URL(next.href);
        if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid pagination');
        seen.add(url.href);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Pagination failed');
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = documentPage.querySelector('[data-recipes]');
        if (!incoming) throw new Error('Missing recipes');
        incoming.querySelectorAll('[data-recipe-card]').forEach(card => grid.appendChild(card));
        const following = incoming.querySelector('[data-next-page]');
        next.remove();
        next = following;
        if (next) root.appendChild(next);
      }
    } catch {
      root.querySelector('[data-load-error]').hidden = false;
    }
    const cards = Array.from(root.querySelectorAll('[data-recipe-card]')).sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order));
    cards.forEach(card => grid.appendChild(card));
    const input = root.querySelector('input');
    const select = root.querySelector('select');
    const clear = root.querySelector('[data-clear]');
    const count = root.querySelector('[data-count]');
    const params = new URLSearchParams(location.search);
    [...new Set(cards.map(card => card.dataset.mode))].forEach(mode => {
      const option = document.createElement('option'); option.value = mode; option.textContent = mode; select.appendChild(option);
    });
    const searchData = new Map(cards.map(card => [card, compact(card.dataset.search)]));
    input.value = params.get('q') || '';
    select.value = params.get('mode') || '';
    function filter() {
      const terms = input.value.normalize('NFKC').trim().split(/\s+/u).map(compact).filter(Boolean);
      let visible = 0;
      cards.forEach(card => {
        card.hidden = Boolean(select.value && card.dataset.mode !== select.value) || !terms.every(term => searchData.get(card).includes(term));
        if (!card.hidden) visible++;
        const link = card.querySelector('[data-recipe-link]');
        const url = new URL(link.href);
        [['q', input.value], ['mode', select.value]].forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
        link.href = url.toString();
      });
      count.textContent = count.dataset.template.replace('__COUNT__', visible).replace('__TOTAL__', cards.length);
      root.querySelector('[data-empty]').hidden = visible !== 0;
      clear.disabled = !input.value && !select.value;
      const url = new URL(location.href);
      [['q', input.value], ['mode', select.value]].forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      history.replaceState(null, '', url);
    }
    function reset() { input.value = ''; select.value = ''; filter(); input.focus(); }
    input.addEventListener('input', event => { if (!event.isComposing) filter(); });
    input.addEventListener('compositionend', filter);
    select.addEventListener('change', filter);
    clear.addEventListener('click', reset);
    input.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); if (event.key === 'Escape') { event.preventDefault(); reset(); } });
    root.querySelector('[data-filters]').hidden = false;
    filter();
  }
  function init() {
    const params = new URLSearchParams(location.search);
    document.querySelectorAll('[data-recipe-back]').forEach(link => {
      const url = new URL(link.href);
      ['q', 'mode'].forEach(key => { if (params.get(key)) url.searchParams.set(key, params.get(key)); });
      link.href = url.toString();
    });
    document.querySelectorAll('[data-recipes]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunruck-manual-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sr-manual-list')) {
    class SunruckManualList extends HTMLElement {
      static query = '';
      static pending = false;

      static compact(value) {
        return String(value).normalize('NFKC').toLowerCase()
          .replace(/[\u2010-\u2015\u2212\uFE58\uFE63-]/g, '')
          .replace(/([a-z0-9])ー(?=[a-z0-9])/g, '$1')
          .replace(/\s+/gu, '');
      }

      static schedule() {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          this.refresh();
        });
      }

      static refresh() {
        const roots = Array.from(document.querySelectorAll('sr-manual-list'));
        const terms = this.query.normalize('NFKC').trim().split(/\s+/u).map(this.compact).filter(Boolean);
        const listIds = roots.map(root => root.querySelector('.sr-manual__grid').id).join(' ');
        let total = 0;
        let matched = 0;

        roots.forEach((root, index) => {
          const search = root.querySelector('[data-sr-search]');
          const input = root.querySelector('[data-sr-input]');
          search.hidden = index !== 0;
          input.value = this.query;
          input.setAttribute('aria-controls', listIds);
          root.querySelector('[data-sr-clear]').disabled = !this.query;
          let categoryMatches = 0;

          root.querySelectorAll('.sr-manual__card').forEach(card => {
            const title = card.dataset.srTitle || '';
            const fields = [title, ...(card.dataset.srModels || '').split(/\r?\n/u)].map(this.compact);
            const searchable = Boolean(title.trim());
            const visible = terms.length === 0 || searchable && terms.every(term => fields.some(field => field.includes(term)));
            card.hidden = !visible;
            if (searchable) {
              total += 1;
              if (visible) {
                matched += 1;
                categoryMatches += 1;
              }
            }
          });

          const hideCategory = terms.length > 0 && categoryMatches === 0;
          root.querySelector('[data-sr-category]').hidden = hideCategory;
          root.hidden = index !== 0 && hideCategory;
        });

        roots.forEach((root, index) => {
          const search = root.querySelector('[data-sr-search]');
          const status = root.querySelector('[data-sr-status]');
          const message = index === 0 ? search.dataset.countTemplate.replace('__COUNT__', matched).replace('__TOTAL__', total) : '';
          if (status.textContent !== message) status.textContent = message;
          root.querySelector('[data-sr-no-results]').hidden = index !== 0 || matched !== 0;
        });
      }

      connectedCallback() {
        if (!this.bound) {
          this.bound = true;
          this.addEventListener('input', event => {
            if (!event.target.matches('[data-sr-input]') || event.isComposing) return;
            SunruckManualList.query = event.target.value;
            SunruckManualList.refresh();
          });
          this.addEventListener('compositionend', event => {
            if (!event.target.matches('[data-sr-input]')) return;
            SunruckManualList.query = event.target.value;
            SunruckManualList.refresh();
          });
          this.addEventListener('click', event => {
            if (!event.target.closest('[data-sr-clear]')) return;
            SunruckManualList.clear(this);
          });
          this.addEventListener('keydown', event => {
            if (event.key === 'Enter' && event.target.matches('[data-sr-input]')) event.preventDefault();
            if (event.key !== 'Escape' || !event.target.matches('[data-sr-input]')) return;
            event.preventDefault();
            SunruckManualList.clear(this);
          });
        }
        SunruckManualList.schedule();
      }

      disconnectedCallback() {
        SunruckManualList.schedule();
      }

      static clear(root) {
        this.query = '';
        this.refresh();
        const first = document.querySelector('sr-manual-list');
        (first || root).querySelector('[data-sr-input]').focus();
      }
    }

    customElements.define('sr-manual-list', SunruckManualList);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => {
      document.addEventListener(name, () => SunruckManualList.schedule());
    });
    ['shopify:block:select', 'shopify:section:select'].forEach(name => {
      document.addEventListener(name, event => {
        const root = event.target.closest('sr-manual-list') || event.target.querySelector('sr-manual-list');
        if (root && SunruckManualList.query) {
          SunruckManualList.query = '';
          SunruckManualList.refresh();
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
